import { FC } from "react"

import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { IGroupImportResult } from "ts/interfaces/Group"

import { getSkippedRowsCount } from "./addMissingStudentsResult"

interface IAddMissingStudentsSummaryProps {
  result: IGroupImportResult
}

const AddMissingStudentsSummary: FC<IAddMissingStudentsSummaryProps> = ({
  result,
}) => {
  const { t } = useTranslation()
  const skippedRowsCount = getSkippedRowsCount(result)

  return (
    <Stack gap={1}>
      <Typography variant="body1" fontWeight="500" color="mockup.darkBlue">
        {t("group.importCompleteGroupsCreated", { count: result.imported })}
      </Typography>
      {result.enrolled.length > 0 && (
        <Typography variant="body1" fontWeight="500" color="mockup.darkBlue">
          {t("group.importCompleteStudentsAdded", {
            count: result.enrolled.length,
          })}
        </Typography>
      )}
      {skippedRowsCount > 0 && (
        <Typography variant="body2" color="mockup.neutral10">
          {t("group.importCompleteRowsSkipped", { count: skippedRowsCount })}
        </Typography>
      )}
    </Stack>
  )
}

export default AddMissingStudentsSummary
